import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface ComposeNewCoAuthorData {
    email: string;
    firstName: string;
    lastName: string;
    title?: string;
}

export class ComposeNewCoAuthor implements FormValidationModel<ComposeNewCoAuthorData> {
    public data: ComposeNewCoAuthorData;
    public rules: yup.Schema<ComposeNewCoAuthorData>;

    public constructor() {
        this.data = {
            email: "",
            firstName: "",
            lastName: "",
        };
        this.rules = yup.object<ComposeNewCoAuthorData>().shape({
            email: yup.string().email().label("Email address").required(),
            firstName: yup.string().label("First name").required().max(50),
            lastName: yup.string().label("Last name").required().max(50),
            title: yup.string().label("Title").max(100),
        });
    }
}

export const ComposeNewCoAuthorSchema = new ComposeNewCoAuthor().rules;

export const DefaultComposeNewCoAuthor: ComposeNewCoAuthorData = new ComposeNewCoAuthor().data;



// WEBPACK FOOTER //
// ./src/forms/abstract/ComposeNewCoAuthor.ts